import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { HOTEL } from "@/data/hotel";

export default function AdminLogin() {
  const { login, user, checking } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!checking && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: "#FAF4E6" }}
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={HOTEL.logo} alt="Azulo Hotels" className="h-14 mx-auto mb-5 object-contain" />
          <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase text-[#A48352]">
            <Lock className="w-3.5 h-3.5" /> Staff Access
          </div>
          <h1 className="mt-2 font-serif text-3xl text-[#1E1A14]">Reservations Console</h1>
          <p className="text-sm text-[#8F7858] mt-1">Sign in to view enquiries</p>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-white border border-[#c4b4a0] rounded-2xl p-8 shadow-[0_20px_60px_-25px_rgba(30,26,20,0.35)]"
        >
          <div className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-[#1E1A14]">Email</Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@azulohotels.com"
                className="mt-1.5 border-[#c4b4a0]"
                data-testid="admin-login-email"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-[#1E1A14]">Password</Label>
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="mt-1.5 border-[#c4b4a0]"
                data-testid="admin-login-password"
              />
            </div>
            {error && (
              <p className="text-sm text-red-600" data-testid="admin-login-error">
                {error}
              </p>
            )}
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#A48352] hover:bg-[#8F7858] text-white rounded-full h-11 tracking-wide"
              data-testid="admin-login-submit"
            >
              {loading ? "Signing in…" : "Sign In"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
